export const activateScreen = (channel, screenName) => {
  document.querySelectorAll(`.${channel}__screen`).forEach((elem) => {
    elem.classList.add(`${channel}__inactive`)
  })
  document.querySelector(`.${channel}__${screenName}`).classList.remove(`${channel}__inactive`)
}
